import { accountActivateSubscriptionGuard } from '@/guards/account-activate-subscription-guard';
import { accountActivateSubscriptionContactGuard } from '@/guards/account-activate-subscription-contact-guard';
import { accountReactivateGuard } from '@/guards/account-reactivate-guard';
import { accountReactivateContactGuard } from '@/guards/account-reactivate-contact-guard';

const AccountCustomizationBranding = () =>
    import('@/views/account/settings/magic-branding/account-customization-branding-view');
const AccountCustomizationBrandingCollateral = () =>
    import('@/views/account/settings/account-customization-branding-collateral-view');
const AccountCustomizationBrandingLandingPage = () =>
    import('@/views/account/settings/account-customization-branding-landing-view');
const AccountCustomizationBrandingDocument = () =>
    import('@/views/account/settings/account-customization-branding-document-view');
const AccountInactiveView = () => import('@/views/account/account-inactive-view.vue');
const AccountConnectwiseInactiveView = ()  => import('@/views/account/account-connectwise-inactive-view.vue');
const AccountReactivation = () => import('@/views/account/account-reactivation-view.vue');
const AccountActivateSubscriptionView = () => import('@/views/account/account-activate-subscription-view.vue');
const AccountActivateSubscriptionContactView = () => import('@/views/account/account-activate-subscription-contact-view.vue');

// Magic Branding Routes
const AccountCustomizationBrandingManualIndex = () =>
    import('@/views/account/settings/magic-branding/account-customization-branding-manual-index-view');
const AccountCustomizationAuto = () =>
import('@/views/account/settings/magic-branding/account-customization-branding-auto-view');
const AccountCustomizationBrandingEditIndex = () =>
import('@/views/account/settings/magic-branding/account-customization-branding-edit-index-view');

export default [
    {
        path: '/Account/Customization/Branding',
        name: 'BrandingIndex',
        component: AccountCustomizationBranding,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-page',
            pageTitle: 'Magic Branding',
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding',
        name: 'ClientBrandingIndex',
        component: AccountCustomizationBranding,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-page',
            pageTitle: 'Magic Branding',
        },
    },
    {
        path: '/Account/Customization/Branding/Auto',
        name: 'BrandingAutoIndex',
        component: AccountCustomizationAuto,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-auto',
            pageTitle: 'Automatic Magic Branding Builder',
        },
        beforeEnter: (to, from, next) => {
            if (from.name === 'BrandingIndex') {
                next();
            } else {
                next('/Account/Customization/Branding');
            }
        }
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Auto',
        name: 'ClientBrandingAutoIndex',
        component: AccountCustomizationAuto,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-auto',
            pageTitle: 'Automatic Magic Branding Builder',
        },
        beforeEnter: (to, from, next) => {
            if (from.name === 'ClientBrandingIndex') {
                next();
            } else {
                next('/Clients/:clientId/Account/Customization/Branding');
            }
        }
    },
    {
        path: '/Account/Customization/Branding/LandingPage',
        name: 'BrandingLandingPageIndex',
        component: AccountCustomizationBrandingLandingPage,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-landing-page',
            pageTitle: 'Landing Page Builder Branding',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/LandingPage',
        name: 'ClientBrandingLandingPageIndex',
        component: AccountCustomizationBrandingLandingPage,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-landing-page',
            pageTitle: 'Landing Page Builder Branding',
        },
    },
    {
        path: '/Account/Customization/Branding/Collateral',
        name: 'BrandingCollateralIndex',
        component: AccountCustomizationBrandingCollateral,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-collateral-page',
            pageTitle: 'Collateral Builder Branding',

        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Collateral',
        name: 'ClientBrandingCollateralIndex',
        component: AccountCustomizationBrandingCollateral,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-collateral-page',
            pageTitle: 'Collateral Builder Branding',
        },
    },
    {
        path: '/Account/Customization/Branding/Document',
        name: 'BrandingDocumentIndex',
        component: AccountCustomizationBrandingDocument,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-document',
            pageTitle: 'Documents & Quoting Branding',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Document',
        name: 'ClientBrandingDocumentIndex',
        component: AccountCustomizationBrandingDocument,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-document',
            pageTitle: 'Documents & Quoting Branding',
        },
    },
    {
        path: '/Account/Customization/Branding/Manual',
        name: 'BrandingManualIndex',
        component: AccountCustomizationBrandingManualIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-manual-logo',
            pageTitle: 'Manual Branding',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Manual',
        name: 'ClientBrandingManualIndex',
        component: AccountCustomizationBrandingManualIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-manual-logo',
            pageTitle: 'Manual Branding',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/Logos',
        name: 'BrandingManualEditLogos',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-logos',
            pageTitle: 'Edit Logos',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/Logos',
        name: 'ClientBrandingEditLogos',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-logos',
            pageTitle: 'Edit Logos',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/Colors',
        name: 'BrandingManualEditColors',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-colors',
            pageTitle: 'Edit Colors',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/Colors',
        name: 'ClientBrandingEditColors',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-colors',
            pageTitle: 'Edit Colors',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/Fonts',
        name: 'BrandingManualEditFonts',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-fonts',
            pageTitle: 'Edit Fonts',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/Fonts',
        name: 'ClientBrandingEditFonts',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-fonts',
            pageTitle: 'Edit Fonts',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/Buttons',
        name: 'BrandingManualEditButtons',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-buttons',
            pageTitle: 'Edit Buttons',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/Buttons',
        name: 'ClientBrandingEditButtons',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-buttons',
            pageTitle: 'Edit Buttons',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/SocialMedia',
        name: 'BrandingManualEditSocialMedia',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-social-media',
            pageTitle: 'Edit Social Media',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/SocialMedia',
        name: 'ClientBrandingEditSocialMedia',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-social-media',
            pageTitle: 'Edit Social Media',
        },
    },
    {
        path: '/Account/Customization/Branding/Edit/CompanyInfo',
        name: 'BrandingManualEditCompanyInfo',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-company-info',
            pageTitle: 'Edit Company Info',
        },
    },
    {
        path: '/Clients/:clientId/Account/Customization/Branding/Edit/CompanyInfo',
        name: 'ClientBrandingEditCompanyInfo',
        component: AccountCustomizationBrandingEditIndex,
        meta: {
            subtype: 'account',
            isUiShown: true,
            pageClass: 'account-customization-branding-edit-company-info',
            pageTitle: 'Edit Company Info',
        },
    },
    {
        path: '/Account/Inactive',
        name: 'AccountInactive',
        component: AccountInactiveView,
    },
    {
        path: '/Account/ConnectWise/Inactive',
        name: 'AccountConnectWiseInactive',
        component: AccountConnectwiseInactiveView
    },
    {
        path: '/Account/ActivateSubscription',
        name: 'AccountActivateSubscription',
        component: AccountActivateSubscriptionView,
        meta: {
            subtype: 'account',
            isUiShown: false,
            pageTitle: 'Activate Subscription',
        },
        beforeEnter: accountActivateSubscriptionGuard,
    },
    {
        path: '/Account/ActivateSubscription/Contact',
        name: 'AccountActivateSubscriptionContact',
        component: AccountActivateSubscriptionContactView,
        meta: {
            subtype: 'account',
            isUiShown: false,
            pageTitle: 'Contact your Administrator',
        },
        beforeEnter: accountActivateSubscriptionContactGuard,
    },
    {
        path: '/Account/Reactivate',
        name: 'ReactivateAccount',
        component: AccountReactivation,
        meta: {
            isUiShown: false,
            subtype: 'account',
            pageClass: 'account-reactivate-page',
            pageTitle: 'Account Reactivation'
        },
        beforeEnter: accountReactivateGuard,
    },
    {
        path: '/Account/Reactivate/Contact',
        name: 'ReactivateAccountContact',
        component: AccountActivateSubscriptionContactView,
        meta: {
            isUiShown: false,
            subtype: 'account',
            pageClass: 'account-reactivate-contact-page',
            pageTitle: 'Contact your Administrator'
        },
        beforeEnter: accountReactivateContactGuard,
    },
    {
        path: '/Clients/:clientId/Account/Reactivate',
        name: 'ClientsReactivateAccount',
        component: AccountReactivation,
        meta: {
            isUiShown: false,
            subtype: 'account',
            pageClass: 'account-reactivate-page',
            pageTitle: 'Account Reactivation'
        }
    },
];
